// extracted by mini-css-extract-plugin
export default {"availableTime":"sUk8uX"};